import type {
  LandingSettings,
  NotificationMode,
  Stage3EmailState,
} from "@/interfaces/CampaignBuilder";

/** The recipient's "Skip video" control shows only during the video phase: opted in, splash gone,
 * video not yet ended or skipped, and the campaign doesn't skip unboxing altogether. */
export function isSkipVisible({
  optedIn,
  introVisible,
  finished,
  skipUnboxing,
}: {
  optedIn: boolean;
  introVisible: boolean;
  finished: boolean;
  skipUnboxing: boolean;
}): boolean {
  return optedIn && !introVisible && !finished && !skipUnboxing;
}

/**
 * Logo for the unbox reveal. Mirrors the API's toRedemptionConfig rule so the builder preview
 * shows exactly what the recipient sees: GfG send uses the email logo, manual send the landing
 * logo (or the email logo while the two are synced).
 */
export function resolveUnboxingLogoUrl(
  email: Pick<Stage3EmailState, "logoEnabled" | "logoUrl">,
  landing: Pick<LandingSettings, "logoEnabled" | "logoUrl" | "logoSynced">,
  notificationMode: NotificationMode,
): string | undefined {
  const url =
    notificationMode === "gfg"
      ? email.logoEnabled
        ? email.logoUrl
        : undefined
      : landing.logoEnabled
        ? landing.logoSynced
          ? email.logoUrl
          : landing.logoUrl
        : undefined;
  return url?.trim() ? url : undefined;
}
